import { useEffect, useState } from 'react';
import { MipClassifierRes } from '@dealstack/shared/lib/generated';

interface Props {
	opened: boolean;
	classifier: MipClassifierRes | null;
	onSave: (data: { mipClassifierId?: string; name: string }) => void;
}

export const useManageClassifierDrawer = ({ opened, classifier, onSave }: Props) => {
	const isEditMode = !!classifier;
	const [name, setName] = useState(classifier?.name ?? '');

	useEffect(() => {
		if (opened) {
			setName(classifier?.name ?? '');
		}
	}, [opened, classifier]);

	const trimmed = name.trim();
	const isFormValid = trimmed.length > 0 && (!classifier || trimmed !== classifier.name);

	const handleSave = () => {
		if (!isFormValid) {
			return;
		}
		onSave({ mipClassifierId: classifier?.id, name: trimmed });
	};

	return {
		name,
		setName,
		handleSave,
		isFormValid,
		isEditMode,
	};
};
